import React from 'react';
import ProjectList from './components/ProjectList';
import './index.css';
import Skills from './components/Skills';
import GameJamList from './components/GameJamList';
import NavBar from './components/NavBar';
import About from './components/About';
import Contact from './components/Contact';

function App() {
	return (
		<div className="min-h-screen bg-fancy-pattern text-gray-900 font-sans">
			<NavBar />

			<header className="text-white pt-10 pb-2 px-4 sm:pl-4">
				<div className="max-w-4xl bg-black/90 rounded-xl border border-red-400/30 shadow-lg shadow-black/40 px-6 py-8 flex flex-col sm:flex-row items-center sm:items-start gap-6 text-center sm:text-left">

					{/* Profile Picture */}
					<img
						src="/images/profile.png"
						alt="Noah Forest"
						className="w-56 h-56 rounded-full object-cover border-4 border-red-400 shadow-md shadow-red-400/20 flex-shrink-0"
					/>

					{/* Text Content */}
					<div className="text-center sm:text-left w-full">
						<h1 className="text-3xl sm:text-4xl font-bold text-red-400 tracking-tight">Noah Forest, 26</h1>
						<p>Co-Founder of <span className="font-bold text-red-300"><a href="https://glumpis.itch.io/" target="_blank" rel="noopener noreferrer">Glumpis Games</a></span></p>

						<div className="flex flex-wrap justify-center sm:justify-start gap-2 mt-3">
							<span className="bg-red-900/40 text-red-200 text-sm font-medium px-3 py-1 rounded-full border border-red-400/30">Game Designer</span>
							<span className="bg-red-900/40 text-red-200 text-sm font-medium px-3 py-1 rounded-full border border-red-400/30">UI/UX Designer</span>
							<span className="bg-red-900/40 text-red-200 text-sm font-medium px-3 py-1 rounded-full border border-red-400/30">Programmer</span>
						</div>

						<div className="flex flex-col gap-2 mt-5">
							<div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 bg-white/5 border border-red-400/20 rounded-lg px-4 py-2">
								<span className="text-red-300 font-bold text-sm shrink-0">2023</span>
								<span className="hidden sm:inline text-white/20">|</span>
								<p className="text-white text-sm sm:text-base">
									<span className="font-bold text-red-300">Certificate of Game Design</span> — Full Sail University · 3.75 GPA
								</p>
							</div>
							<div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 bg-white/5 border border-red-400/20 rounded-lg px-4 py-2">
								<span className="text-red-300 font-bold text-sm shrink-0">2018</span>
								<span className="hidden sm:inline text-white/20">|</span>
								<p className="text-white text-sm sm:text-base">
									High School Diploma — Dover Senior High School
								</p>
							</div>
						</div>
					</div>

				</div>
			</header>

			<About />
			<Skills />
			<ProjectList />
			<GameJamList />
			<Contact />
		</div>
	);
}

export default App;